import { takeLatest, put, call } from "redux-saga/effects"
import {
  createCategoryService,
  fetchCategoryListService,
  updateCategoryService,
} from "../services/categoryService"
import {
  addCategory,
  addCategoryFailed,
  addCategoryPayloadType,
  addCategorySuccess,
  fetchCategoryList,
  fetchCategoryListFailed,
  fetchCategoryListPayloadType,
  fetchCategoryListSuccess,
  initialFilterState,
  initialPaginationState,
  updateCategory,
  updateCategoryFailed,
  updateCategoryPayloadType,
  updateCategorySuccess,
} from "../slices/categorySlice"
import { Category } from "../models/category.model"
import { PayloadAction } from "@reduxjs/toolkit"
import { showToast } from "../slices/toastSlice"

export function* getCategoryListSaga(
  action: PayloadAction<fetchCategoryListPayloadType>,
) {
  try {
    const { category } = action.payload
    const { data } = yield call(fetchCategoryListService, action.payload)

    yield put(
      fetchCategoryListSuccess({
        category,
        categoryList: data?.data?.map((category: any) => ({
          ...new Category(category),
        })),
        totalRowCount: data?.pagination?.total_count,
      }),
    )
  } catch (err) {
    const { category } = action.payload
    yield put(fetchCategoryListFailed({ category }))
  }
}

export function* createCategorySaga(
  action: PayloadAction<addCategoryPayloadType>,
) {
  try {
    const { message } = yield call(createCategoryService, action.payload)
    yield put(addCategorySuccess(action.payload))
    yield put(
      showToast({
        toastType: "success",
        msg: message || "Category created successfully",
      }),
    )
    yield put(
      fetchCategoryList({
        category: action.payload.category,
        ...initialPaginationState,
        ...initialFilterState(),
        level: action.payload.level,
      }),
    )
  } catch (err) {
    yield put(addCategoryFailed(action.payload))
  }
}
export function* updateCategorySaga(
  action: PayloadAction<updateCategoryPayloadType>,
) {
  try {
    const { message } = yield call(updateCategoryService, action.payload)
    yield put(updateCategorySuccess(action.payload))
    yield put(
      showToast({
        toastType: "success",
        msg: message || "Category updated successfully",
      }),
    )
    yield put(
      fetchCategoryList({
        category: action.payload.category,
        ...initialPaginationState,
        ...initialFilterState(),
        level: action.payload.level,
      }),
    )
  } catch (err) {
    yield put(updateCategoryFailed(action.payload))
  }
}

export default function* CategorySaga() {
  yield takeLatest(fetchCategoryList, getCategoryListSaga)
  yield takeLatest(addCategory, createCategorySaga)
  yield takeLatest(updateCategory, updateCategorySaga)
}
